import React, { FC, ReactNode } from 'react';

import { Box, Flex, Stack } from '@chakra-ui/react';
import backgroundMissing from 'images/Background-Missing.jpg';

import { PrimaryButton } from 'components/DataEntry';

import {
  GettingStartedList,
  GettingStartedListStylesProps,
} from './GettingStartedList';

interface Props {
  header?: string;
  content?: ReactNode;
  steps?: {
    label: string;
    component?: ReactNode;
    header?: string;
    key: string;
    onClick?();
  }[];
  footer?: string;
  onClickFooter?();
  listStyles?: GettingStartedListStylesProps;
}

export const GettingStartedComponent: FC<Props> = props => {
  const { header, steps, footer, onClickFooter, content, listStyles } = props;

  return (
    <Box
      pl={24}
      py={3}
      backgroundImage={backgroundMissing}
      w="full"
      minH="max(100%, 700px)"
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
      borderRadius={6}
    >
      <Stack color="white" pt={6} pl={1} pr={32} spacing={10} w="full">
        {header && (
          <Box fontSize="3xl" pl={14}>
            {header}
          </Box>
        )}
        {content}
        {steps && <GettingStartedList steps={steps} styles={listStyles} />}
        {footer && (
          <Flex>
            <Box pt={10} pl={12}>
              <PrimaryButton
                size="lg"
                onClick={onClickFooter}
                bg="primary"
                color="white"
              >
                {footer}
              </PrimaryButton>
            </Box>
          </Flex>
        )}
      </Stack>
    </Box>
  );
};
